import { Dashboard } from "./dashboard";
import { Projects } from "./projects";
import { Project } from "./project";
import { Notes } from "./notes";
import { Pages } from "./pages";
import { Discover } from "./discover";
import { Search } from "./search";

export const AppRoutes = [
  ["/dashboard", Dashboard, "Dashboard"],
  ["/projects", Projects, "Projects"],
  ["/projects/:projectId", Project, "Project"],
  ["/projects/:projectId/pages", Pages, "Pages"],
  ["/projects/:projectId/notes", Notes, "Notes"],
  ["/projects/:projectId/search", Search, "Search"],
  ["/projects/:projectId/discover", Discover, "Discover"],
];
